<div class="root" [class.checked]="checked" [class.disabled]="disabled" [class.expandable]="expandable" (click)="onCardClick($event)">
    <p-radioButton [inputId]="inputId" [value]="radioValue" [name]="name" [disabled]="disabled"
        [ngModel]="effectiveValue" (onChange)="onRadioChange($event)" />
    <label [attr.for]="expandable ? null : inputId" class="label">{{ title }}</label>
</div>